<template>
  <div class="MethodOpisBlock">
    <div class="VisBt On" v-if="showEditLink" v-show="card.visible" @click="makeInvisible"></div>
    <div class="VisBt Off" v-if="showEditLink" v-show="!card.visible" @click="makeVisible"></div>
    <div class="EditBt Edit" v-if="showEditLink" @click="toggleAction"></div>
    <div class="MMarkers">
      <router-link
        v-for="tagId in card.tag_ids"
        :key="tagId"
        :to="{ name: 'tag', params: { id: tagId }}"
      >
        <img class="MP"
          :title="tag(tagId).name"
          :src="`/img/fpd-${tagId}.png`"
        />
      </router-link>
    </div>
    <div class="MyIconBt Add" @click="addToFavorites" v-show="authorized && !isFavoriteCard(card)"></div>
    <div class="MyIconBt Remove" @click="removeFromFavorites" v-show="authorized && isFavoriteCard(card)"></div>
    <div class="MyTakeNum">{{ card.favorites_count }}</div>
    <div class="MMName">{{ card.name_big }}</div>
    <div class="MVName">{{ card.name_small }}</div>
    <div class="MPeople">{{ card.people }}</div>
    <div class="MHours">{{ card.time }}</div>
    <div class="MIBlock">{{ card.announcement }}</div>
    <!-- <div class="MObnovlenie"></div> -->
  </div>
</template>

<script>
import { pick, isEmpty } from 'lodash';
import { API_ROOT } from "@/utils/api_root";
import { mapGetters } from 'vuex';

export default {
  props: {
    card: { type: Object, default: function() { return {}; } },
    showEditLink: { type: Boolean, default: function() { return false; } },
    toggleAction: Function,
    saveDataColumns: Function,
    saveDataParams: Function,
  },
  data() {
    return {
      columnNames: {'people': 'численность', 'time': 'время провидения',
                    'announcement': 'анонс', 'description_text': 'краткое описание',
                    'useit': 'применения', 'tag_ids': 'таги'}
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'authorized', 'tag']),
    // tagIds() {
    //   return this.card.tag_ids.sort();
    // }
  },
  methods: {
    makeVisible() {
      if (this.validateMakeVisible())
        this.saveDataParams({card: {visible: true}}, false, ['visible']);
    },
    validateMakeVisible() {
      const emptyColumns =
        ['people', 'time', 'announcement', 'description_text', 'useit', 'tag_ids'].
          filter(column => isEmpty(this.card[column]) ).
          map(column => this.columnNames[column] );
      if (!isEmpty(emptyColumns))
        this.flash('Для публикации необходимо заполнить поля: ' + emptyColumns.join(', ') + '.', 'error');
      return isEmpty(emptyColumns);
    },
    makeInvisible() {
      this.saveDataParams({card: {visible: false}}, false, ['visible']);
    },
    addToFavorites() {
      this.card.favorites_count = this.card.favorites_count + 1;
      this.$http.put(`${API_ROOT}/users/${this.currentUser.id}/favorite_cards/${this.card.id}.json`)
        .then(response => {
            this.flash('Данные сохранены', 'success', {timeout: 3000});
            this.currentUser.favorite_card_ids = response.data.favorite_card_ids;
            this.card.favorites_count = response.data.favorites_count;
            console.log('addToFavorites response.data', response.data);
        })
        .catch(error => {
          console.log('addToFavorites error', error, error.response);
          this.flash('Ошибка сохранения', 'error');
          // this.cardOpisErrors = error.response.data;
        });
    },
    removeFromFavorites() {
      this.card.favorites_count = this.card.favorites_count - 1;
      this.$http.delete(`${API_ROOT}/users/${this.currentUser.id}/favorite_cards/${this.card.id}.json`)
        .then(response => {
            console.log('removeFromFavorites response.data', response.data);
            this.flash('Данные сохранены', 'success', {timeout: 3000});
            this.currentUser.favorite_card_ids = response.data.favorite_card_ids;
            this.card.favorites_count = response.data.favorites_count;
        })
        .catch(error => {
          console.log('addToFavorites error', error, error.response);
          this.flash('Ошибка сохранения', 'error');
          // this.cardOpisErrors = error.response.data;
        });
    },
    isFavoriteCard(card) {
      console.log('currentUser', this.currentUser);
      return this.currentUser.favorite_card_ids.includes(card.id);
    },
  },
};
</script>

<style>
</style>
